const Loader = () => {
    return (
        <>
            <img src="./images/svgs/loading.svg" alt="loading" />
        </>
    );
}

export default Loader;